import type { AioShopperInfo, CoBuyer, IShopper } from '@makemydeal/dr-platform-types';
import type { SaveParticipantsPayload } from './participantsMapper';

export type SwappedParticipants = {
    nextBuyer: Partial<AioShopperInfo>;
    nextCoBuyer: CoBuyer;
};

export const swapParticipantRoles = (buyer: IShopper, coBuyer: CoBuyer): SwappedParticipants => {
    const { participantRole, relationshipToBuyer, ...nextBuyer } = coBuyer;

    return {
        nextBuyer: nextBuyer as Partial<AioShopperInfo>,
        nextCoBuyer: {
            ...buyer,
            ...(participantRole && { participantRole }),
            ...(relationshipToBuyer && { relationshipToBuyer })
        } as CoBuyer
    };
};

export const buildSwappedParticipants = (buyer: IShopper, coBuyer: CoBuyer, dealerUser?: string): SaveParticipantsPayload => {
    const { nextBuyer, nextCoBuyer } = swapParticipantRoles(buyer, coBuyer);

    return {
        buyer: nextBuyer,
        coBuyer: nextCoBuyer,
        ...(dealerUser && { dealerUser })
    };
};
